import InlineEditGroup from 'shared-assets/components/PatientIntake/InlineEditGroup';

angular
  .module('kareo.ui.shared.directives.inline-edit-group', [
    'react'
  ])
  .directive('inlineEditGroup', dcInlineEditGroup);

dcInlineEditGroup.$inject = ['reactDirective'];

function dcInlineEditGroup(reactDirective) {
  const bindings = {
    edit: '=',
    error: '=',
    inputProps: '=',
    inputMaskProps: '=',
    inputRef: '=',
    isSaving: '=',
    onSave: '=',
    onBlur: '=',
    onChange: '=',
    style: '=',
    template: '=',
    data: '=',
  };

  return reactDirective(InlineEditGroup, bindings, props => {
    return props;
  });
}